var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',_vm._l((8),function(n){return _c('v-col',{key:n,attrs:{"cols":"12","sm":"6","md":"4","lg":"3"}},[_c('v-skeleton-loader',{staticClass:"ma-3",attrs:{"type":"image, card-heading","height":"300"}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }